<template>
    <div class="col-12">
        <h4 class="header-title m-t-0">
            <i class="fas fa-hand-holding-usd mr-1"/>
            <span v-html="$t('CarrierTaxList.carrierTaxes')"/>
        </h4>
        <hr/>
        <v-client-table :data="carrier.taxes" :columns="table.columns" :options="table.options">
            <button @click="showCarrierTaxModal()" class="btn btn-primary pull-right" slot="afterLimit">
                <i class="fa fa-plus-circle mr-1"/>
                <span v-html="$t('CarrierTaxList.addCarrierTax')"/>
            </button>
            <span slot="type" slot-scope="props">
                <span v-html="props.row.type"/>
            </span>
            <span slot="value" slot-scope="props"  v-if="props.row.type === 'Pourcentage'" v-html="`${props.row.value} %`"/>
            <span slot="value" slot-scope="props"  v-else v-html="`${props.row.value} €`"/>
            <BooleanIcon slot-scope="props" slot="enabledForApi" :boolean="props.row.enabledForApi"/>
            <span slot="country.name" slot-scope="props" v-if="props.row.country.name">
                <img class="shadow mr-1" width="30" alt="flag" :src="getDiceBaseUrl() + props.row.country.flagURL"/>
                <span v-html="props.row.country.name"/>
            </span>
            <span slot="country.name" slot-scope="props" v-else>
                <span v-html="props.row.carrierArea.name"/>
            </span>
            <div class="text-center" slot="actions" slot-scope="props">
                <button v-tooltip="$t('CarrierTaxList.edit')" @click="showCarrierTaxModal(props.row)" class="btn btn-warning btn-xs mr-1">
                    <i class="fa fa-edit"/>
                </button>
                <CarrierTaxDeleteButton v-tooltip="$t('CarrierTaxList.delete')" :carrier-tax="props.row" @deleteCarrierTax="deleteCarrierTax"/>
            </div>
        </v-client-table>
        <CarrierTaxFormModal @addCarrierTax="addCarrierTax" @editCarrierTax="editCarrierTax" :carrier="carrier" ref="CarrierTaxFormModal"/>
    </div>
</template>

<script>
import CarrierTaxFormModal from "./CarrierTaxFormModal";
import CarrierTaxDeleteButton from "./CarrierTaxDeleteButton";
import BooleanIcon from "@/components/shared/misc/BooleanIcon";
import {permissiveFilter} from "../../../../../helpers/VueTable";

export default {
    name: "CarrierTaxList",
    components: {CarrierTaxDeleteButton, CarrierTaxFormModal, BooleanIcon},
    props: {
        carrier: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            table: {
                columns: ["name", "type", "value", "enabledForApi", "country.name", "actions"],
                options: {
                    perPage: 10,
                    sortable: ["name", "type", "value", "enabledForApi", "country.name"],
                    headings: {
                        name: this.$t("CarrierTaxList.name"),
                        type: this.$t("CarrierTaxList.type"),
                        value: this.$t("CarrierTaxList.value"),
                        enabledForApi: this.$t("CarrierTaxList.enabledForApi"),
                        "country.name": this.$t("CarrierTaxList.assignment"),
                    },
                    orderBy: {
                        column: "name",
                    },
                    filterAlgorithm: {
                        name: (row, query) => permissiveFilter(row.name, query),
                        "country.name": (row, query) => permissiveFilter(row.country.name, query),
                    },
                },
            },
        };
    },
    methods: {
        showCarrierTaxModal(carrierTax = null) {
            this.$refs.CarrierTaxFormModal.show(carrierTax);
        },
        addCarrierTax(carrierTax) {
            this.$emit("addCarrierTax", carrierTax);
        },
        editCarrierTax(newCarrierTax) {
            this.$emit("editCarrierTax", newCarrierTax);
        },
        deleteCarrierTax(carrierTax) {
            this.$emit("deleteCarrierTax", carrierTax);
        },
        getDiceBaseUrl() {
            return this.$diceAPI.getBaseUrl();
        },
    },
};
</script>

<style scoped>

</style>